import { useTranslation } from 'next-i18next'

import { Link } from '~/components'
import ROUTES from '~/shared/constants/routes.const'

import MathMagicForUkraineTitle from '~/donation/components/MathMagicForUkraineTitle'
import { homePageGroupPic } from '~/donation/constants/home.const'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

function DonationPage(): React.ReactElement {
  const { t } = useTranslation('donation')

  return (
    <div className="flex flex-col gap-2 max-w-150 min-w-73 m-auto p-4 md:p-2 md:pt-6">
      <div className="shrink w-full max-w-125 min-w-62 bg-white h-fit m-auto rounded p-3 flex-col justify-center items-center">
        <MathMagicForUkraineTitle />
      </div>
      <div className="w-full m-auto">
        <ResponsiveImage
          alt={homePageGroupPic.imageAlt}
          height={267}
          imageClassName="w-80 md:w-120"
          imageWidths="316, 475"
          loading="eager"
          mediaQuery={homePageGroupPic.mediaQuery}
          srcKey={homePageGroupPic.imageSrc}
          width={475}
        />
      </div>
      <div className="w-full">
        <span className="text-white tracking-wide leading-7 text-xs md:text-sm ">{t('homePage.description')}</span>
      </div>
      <div className="w-46 h-12 m-auto my-2 rounded border text-blue-strong font-bold border-blue-strong bg-yellow-golden">
        <Link
          className="w-full h-12 p-2.5 justify-center items-center inline-flex tracking-widest"
          to={ROUTES.MATHMAGIC_DONATE}
        >
          {t('donatePage.title')}
        </Link>
      </div>
    </div>
  )
}

export default DonationPage
